// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	--popup-resizeable-border: 10px;
	--popup-title-bar-size: 20px;
	--popup-title-bar-color: var(--highlight-bg-color);
	--popup-dock-button-size: 15px;
}

.popup-container {
	z-index: 1000;
	position: fixed;
	top: 0px;
	left: 0px;
	height: 100vh;
	width: 100vw;
}

.popup-container.no-modal {
	pointer-events: none;
}

.popup-content {
	position: fixed;
	background-color: var(--main-bg-color);
	color: var(--main-fg-color);
	box-shadow: 0px 0px 4px 0px var(--main-bg-color);
	border-radius: 3px;
	padding: 5px 5px 5px 5px;
	forced-color-adjust: none;
	overflow: auto;
	display: table;
}

.popup-content.static-position {
	box-sizing: border-box;
	user-select: none;
	position: absolute;
	overflow: hidden;
	display: block;
}

.popup-content.moveable {
	padding: 0px;
	cursor: col-resize;
	min-width: 180px;
	min-height: 100px;
}

.popup-container.no-modal .popup-content {
	pointer-events: all;
}

.popup-content.resizeable .border-top-left {
	width: var(--popup-resizeable-border);
	height: var(--popup-resizeable-border);
	cursor: nw-resize;
	float: left;
}

.popup-content.resizeable .border-top-center {
	width: calc(100% - var(--popup-resizeable-border) * 2);
	height: var(--popup-resizeable-border);
	cursor: row-resize;
	float: left;
}

.popup-content.resizeable .border-top-right {
	width: var(--popup-resizeable-border);
	height: var(--popup-resizeable-border);
	cursor: ne-resize;
	float: left;
}

.popup-content .title-bar {
	font-family: arial, sans-serif;
	text-align: center;
	user-select: none;
	box-sizing: border-box;
	overflow: hidden;
}

.popup-content.moveable .title-bar {
	min-height: max(var(--popup-title-bar-size), calc(var(--popup-dock-button-size) + 11px));
	background-color: var(--popup-title-bar-color);
	cursor: move;
	position: relative;
	display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
}

.popup-content.fixed .title-bar.not-empty {
	padding: 5px;
	border-bottom: 1px solid var(--main-fg-color);
}

.popup-content.moveable .title-bar .title-bar-content {
	padding-left: calc(var(--popup-dock-button-size) * 2);
	padding-right: calc(var(--popup-dock-button-size) * 2);
}

.popup-content.moveable.resizeable .title-bar {
	width: calc(100% - var(--popup-resizeable-border) * 2);
	margin-left: var(--popup-resizeable-border);
	margin-right: var(--popup-resizeable-border);
}

.popup-content .popup-action-buttons {
	position: absolute;
	top: 3px;
	right: 3px;
	display: flex;
}

.popup-content button.popup-action-button {
	display: none;
	background-color: transparent;
    border: 1px solid var(--main-fg-color);
	border-radius: 7px;
	cursor: pointer;
	margin-right: 2px;
}

.popup-content button.popup-action-button:hover {
	background-color: var(--highlight-bg-color-hover);
}

.popup-content button.popup-action-button i {
	width: var(--popup-dock-button-size);
	height: var(--popup-dock-button-size);
	display: block;
	color: var(--main-fg-color);
	fill: var(--main-fg-color);
}

.popup-content .center-container {
	width: calc(100% - var(--popup-resizeable-border) * 2);
	margin-left: var(--popup-resizeable-border);
	margin-right: var(--popup-resizeable-border);
	float: left;
}

.popup-content.static-position .center-container {
	height: calc(100% - var(--popup-resizeable-border) * 2 - var(--popup-title-bar-size));
	overflow: auto;
}

/* Begin properties for static position pop up: */
.popup-content.static-position button.popup-action-button {
	display: inline-block;
}

.popup-content.static-position .separator-left {
	width: var(--popup-resizeable-border);
	height: var(--popup-resizeable-border);
	float: left;
}

.popup-content.static-position .separator-right {
	width: var(--popup-resizeable-border);
	height: var(--popup-resizeable-border);
	float: left;
}

.popup-content.static-position .border-bottom-left {
	width: var(--popup-resizeable-border);
	height: var(--popup-resizeable-border);
	cursor: sw-resize;
	float: left;
}

.popup-content.static-position .border-bottom-center {
	width: calc(100% - var(--popup-resizeable-border) * 2);
	height: var(--popup-resizeable-border);
	cursor: row-resize;
	float: left;
}

.popup-content.static-position .border-bottom-right {
	width: var(--popup-resizeable-border);
	height: var(--popup-resizeable-border);
	cursor: se-resize;
	float: left;
}
`, "",{"version":3,"sources":["webpack://./src/css/PopUp.css"],"names":[],"mappings":"AAAA;CACC,+BAA+B;CAC/B,4BAA4B;CAC5B,kDAAkD;CAClD,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,eAAe;CACf,QAAQ;CACR,SAAS;CACT,aAAa;CACb,YAAY;AACb;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,sCAAsC;CACtC,2BAA2B;CAC3B,gDAAgD;CAChD,kBAAkB;CAClB,wBAAwB;CACxB,yBAAyB;CACzB,cAAc;CACd,cAAc;AACf;;AAEA;CACC,sBAAsB;CACtB,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,qCAAqC;CACrC,sCAAsC;CACtC,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,sDAAsD;CACtD,sCAAsC;CACtC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,qCAAqC;CACrC,sCAAsC;CACtC,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,8BAA8B;CAC9B,kBAAkB;CAClB,iBAAiB;CACjB,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,wFAAwF;CACxF,8CAA8C;CAC9C,YAAY;CACZ,kBAAkB;CAClB,aAAa;IACV,eAAe;IACf,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;CACC,YAAY;CACZ,6CAA6C;AAC9C;;AAEA;CACC,qDAAqD;CACrD,sDAAsD;AACvD;;AAEA;CACC,sDAAsD;CACtD,2CAA2C;CAC3C,4CAA4C;AAC7C;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,aAAa;AACd;;AAEA;CACC,aAAa;CACb,6BAA6B;IAC1B,sCAAsC;CACzC,kBAAkB;CAClB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,iDAAiD;AAClD;;AAEA;CACC,oCAAoC;CACpC,qCAAqC;CACrC,cAAc;CACd,2BAA2B;CAC3B,0BAA0B;AAC3B;;AAEA;CACC,sDAAsD;CACtD,2CAA2C;CAC3C,4CAA4C;CAC5C,WAAW;AACZ;;AAEA;CACC,qFAAqF;CACrF,cAAc;AACf;;AAEA,iDAAiD;AACjD;CACC,qBAAqB;AACtB;;AAEA;CACC,qCAAqC;CACrC,sCAAsC;CACtC,WAAW;AACZ;;AAEA;CACC,qCAAqC;CACrC,sCAAsC;CACtC,WAAW;AACZ;;AAEA;CACC,qCAAqC;CACrC,sCAAsC;CACtC,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,sDAAsD;CACtD,sCAAsC;CACtC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,qCAAqC;CACrC,sCAAsC;CACtC,iBAAiB;CACjB,WAAW;AACZ","sourcesContent":[":root {\n\t--popup-resizeable-border: 10px;\n\t--popup-title-bar-size: 20px;\n\t--popup-title-bar-color: var(--highlight-bg-color);\n\t--popup-dock-button-size: 15px;\n}\n\n.popup-container {\n\tz-index: 1000;\n\tposition: fixed;\n\ttop: 0px;\n\tleft: 0px;\n\theight: 100vh;\n\twidth: 100vw;\n}\n\n.popup-container.no-modal {\n\tpointer-events: none;\n}\n\n.popup-content {\n\tposition: fixed;\n\tbackground-color: var(--main-bg-color);\n\tcolor: var(--main-fg-color);\n\tbox-shadow: 0px 0px 4px 0px var(--main-bg-color);\n\tborder-radius: 3px;\n\tpadding: 5px 5px 5px 5px;\n\tforced-color-adjust: none;\n\toverflow: auto;\n\tdisplay: table;\n}\n\n.popup-content.static-position {\n\tbox-sizing: border-box;\n\tuser-select: none;\n\tposition: absolute;\n\toverflow: hidden;\n\tdisplay: block;\n}\n\n.popup-content.moveable {\n\tpadding: 0px;\n\tcursor: col-resize;\n\tmin-width: 180px;\n\tmin-height: 100px;\n}\n\n.popup-container.no-modal .popup-content {\n\tpointer-events: all;\n}\n\n.popup-content.resizeable .border-top-left {\n\twidth: var(--popup-resizeable-border);\n\theight: var(--popup-resizeable-border);\n\tcursor: nw-resize;\n\tfloat: left;\n}\n\n.popup-content.resizeable .border-top-center {\n\twidth: calc(100% - var(--popup-resizeable-border) * 2);\n\theight: var(--popup-resizeable-border);\n\tcursor: row-resize;\n\tfloat: left;\n}\n\n.popup-content.resizeable .border-top-right {\n\twidth: var(--popup-resizeable-border);\n\theight: var(--popup-resizeable-border);\n\tcursor: ne-resize;\n\tfloat: left;\n}\n\n.popup-content .title-bar {\n\tfont-family: arial, sans-serif;\n\ttext-align: center;\n\tuser-select: none;\n\tbox-sizing: border-box;\n\toverflow: hidden;\n}\n\n.popup-content.moveable .title-bar {\n\tmin-height: max(var(--popup-title-bar-size), calc(var(--popup-dock-button-size) + 11px));\n\tbackground-color: var(--popup-title-bar-color);\n\tcursor: move;\n\tposition: relative;\n\tdisplay: flex;\n    flex-wrap: wrap;\n    align-content: center;\n    justify-content: center;\n}\n\n.popup-content.fixed .title-bar.not-empty {\n\tpadding: 5px;\n\tborder-bottom: 1px solid var(--main-fg-color);\n}\n\n.popup-content.moveable .title-bar .title-bar-content {\n\tpadding-left: calc(var(--popup-dock-button-size) * 2);\n\tpadding-right: calc(var(--popup-dock-button-size) * 2);\n}\n\n.popup-content.moveable.resizeable .title-bar {\n\twidth: calc(100% - var(--popup-resizeable-border) * 2);\n\tmargin-left: var(--popup-resizeable-border);\n\tmargin-right: var(--popup-resizeable-border);\n}\n\n.popup-content .popup-action-buttons {\n\tposition: absolute;\n\ttop: 3px;\n\tright: 3px;\n\tdisplay: flex;\n}\n\n.popup-content button.popup-action-button {\n\tdisplay: none;\n\tbackground-color: transparent;\n    border: 1px solid var(--main-fg-color);\n\tborder-radius: 7px;\n\tcursor: pointer;\n\tmargin-right: 2px;\n}\n\n.popup-content button.popup-action-button:hover {\n\tbackground-color: var(--highlight-bg-color-hover);\n}\n\n.popup-content button.popup-action-button i {\n\twidth: var(--popup-dock-button-size);\n\theight: var(--popup-dock-button-size);\n\tdisplay: block;\n\tcolor: var(--main-fg-color);\n\tfill: var(--main-fg-color);\n}\n\n.popup-content .center-container {\n\twidth: calc(100% - var(--popup-resizeable-border) * 2);\n\tmargin-left: var(--popup-resizeable-border);\n\tmargin-right: var(--popup-resizeable-border);\n\tfloat: left;\n}\n\n.popup-content.static-position .center-container {\n\theight: calc(100% - var(--popup-resizeable-border) * 2 - var(--popup-title-bar-size));\n\toverflow: auto;\n}\n\n/* Begin properties for static position pop up: */\n.popup-content.static-position button.popup-action-button {\n\tdisplay: inline-block;\n}\n\n.popup-content.static-position .separator-left {\n\twidth: var(--popup-resizeable-border);\n\theight: var(--popup-resizeable-border);\n\tfloat: left;\n}\n\n.popup-content.static-position .separator-right {\n\twidth: var(--popup-resizeable-border);\n\theight: var(--popup-resizeable-border);\n\tfloat: left;\n}\n\n.popup-content.static-position .border-bottom-left {\n\twidth: var(--popup-resizeable-border);\n\theight: var(--popup-resizeable-border);\n\tcursor: sw-resize;\n\tfloat: left;\n}\n\n.popup-content.static-position .border-bottom-center {\n\twidth: calc(100% - var(--popup-resizeable-border) * 2);\n\theight: var(--popup-resizeable-border);\n\tcursor: row-resize;\n\tfloat: left;\n}\n\n.popup-content.static-position .border-bottom-right {\n\twidth: var(--popup-resizeable-border);\n\theight: var(--popup-resizeable-border);\n\tcursor: se-resize;\n\tfloat: left;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
